<template>
  <div>
    <div class="control_his">
      <div style="background-color: white; padding: 15px 0 15px 20px; text-align: left;">
        <div>
          <span>选择生产单元：</span>
          <el-select v-model="checkedCell" placeholder="请选择生产单元" style="border:1px solid #dcdfe6; width: 280px; border-radius: 4px; margin-right: 20px;">
            <el-option
              v-for="cell in listCell"
              :key="cell.id"
              :label="cell.name"
              :value="cell.id">
            </el-option>
          </el-select >
          <span>设备选择：</span>
          <el-select v-model="equip"  placeholder="请选择设备" style="border:1px solid #dcdfe6; width: 280px; border-radius: 4px; margin-right: 20px;">
            <el-option v-for="(equip,index) in  listEquip_id" :key="index" :label="equip.defname" :value="equip.id"></el-option>
          </el-select>
          <span class="margin_equip">时间选择：</span>
          <el-date-picker
            class="date_pick"
            v-model="his_time1"
            type="datetimerange"
            :picker-options="pickerOptions1"
            align="right"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['12:00:00', '08:00:00']">
          </el-date-picker>
          <el-button type="primary" @click="getAllhis()">确定</el-button>
        </div>
      </div>
    </div>
    <div class="margin_top_table">
      <el-table
        :data="listEquip_time"
        :span-method="objectSpanMethod"
        border>
        <el-table-column prop="num" label="序号"></el-table-column>
        <el-table-column prop="optlist" label="操作"></el-table-column>
        <el-table-column prop="timelist" label="操作时间"></el-table-column>
        <el-table-column prop="ondurt" label="累计开启时间"></el-table-column>
        <el-table-column prop="offdurt" label="累计关闭时间"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      his_time1: [],
      listCell: [],
      checkedCell: '',
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username'),
      pickerOptions1: {
        shortcuts: [{
          text: '最近一天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近半年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      equip: '',
      listEquip_id: [],
      listEquip_time: []
    }
  },
  methods: {
    // 获取 所有生产单元
    getAllCell () {
      this.axios.get(this.$store.state.ip + 'celldef/listUserCells',
        {
          params: {'username': this.username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listCell = res.data.data.list
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取 生产单元下的设备
    getUserEquips () {
      this.axios.get(this.$store.state.ip + 'equipdef/listEquips',
        {
          params: {'cell_id': this.checkedCell},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listEquip_id = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    // 查看设备的更改日志
    getAllhis () {
      this.listEquip_time = []
      this.axios.get(this.$store.state.ip + 'opt/equLogQuery',
        {
          params: {'cell_id': this.checkedCell, 'start_time': this.his_time1[0], 'end_time': this.his_time1[1]},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        for (let i = 0; i < res.data.data.length; i++) {
          if (this.equip === res.data.data[i].eqpid) {
            for (let j = 0; j < res.data.data[i].optlist.length; j++) {
              this.listEquip_time = this.listEquip_time.concat({'num': j + 1})
              this.listEquip_time[j].timelist = this.resetTime(res.data.data[i].timelist[j])
              if (res.data.data[i].optlist[j] === 0) {
                this.listEquip_time[j].optlist = '关闭'
              } else {
                this.listEquip_time[j].optlist = '开启'
              }
              this.listEquip_time[j].ondurt = this.changSecond(res.data.data[i].ondurt)
              this.listEquip_time[j].offdurt = this.changSecond(res.data.data[i].offdurt)
            }
            break
          }
        }
        this.length = this.listEquip_time.length
      }).catch(err => {
        console.log(err)
      })
    },
    // 时间戳转换为标准时间
    resetTime (time) {
      let test = new Date(time * 1000)
      let year = test.getFullYear() // 取得4位数的年份
      let month = ('0' + (test.getMonth() + 1)).slice(-2) // 取得日期中的月份，其中0表示1月，11表示12月
      let date = ('0' + test.getDate()).slice(-2) // 返回日期月份中的天数（1到31）
      let hour = ('0' + test.getHours()).slice(-2) // 返回日期中的小时数（0到23）
      let minute = ('0' + test.getMinutes()).slice(-2) // 返回日期中的分钟数（0到59）
      let second = ('0' + test.getSeconds()).slice(-2) // 返回日期中的秒数（0到59）
      return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
    },
    // 把秒转换为天时分秒
    changSecond (second) {
      let theTime = parseInt(second) // 需要转换的时间秒
      let theTime1 = 0 // 分
      let theTime2 = 0 // 小时
      let theTime3 = 0 // 天
      if (theTime > 60) {
        theTime1 = parseInt(theTime / 60)
        theTime = parseInt(theTime % 60)
        if (theTime1 > 60) {
          theTime2 = parseInt(theTime1 / 60)
          theTime1 = parseInt(theTime1 % 60)
          if (theTime2 > 24) {
            // 大于24小时
            theTime3 = parseInt(theTime2 / 24)
            theTime2 = parseInt(theTime2 % 24)
          }
        }
      }
      let result = ''
      if (theTime > 0) {
        result = '' + parseInt(theTime) + '秒'
      }
      if (theTime1 > 0) {
        result = '' + parseInt(theTime1) + '分' + result
      }
      if (theTime2 > 0) {
        result = '' + parseInt(theTime2) + '小时' + result
      }
      if (theTime3 > 0) {
        result = '' + parseInt(theTime3) + '天' + result
      }
      return result
    },
    // 合并列
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3 || columnIndex === 4) {
        return {
          rowspan: this.length,
          colspan: 1
        }
      }
    }
  },
  created () {
    this.getAllCell()
  },
  watch: {
    'checkedCell': function () {
      this.getUserEquips()
    }
  }
}
</script>

<style scoped>
  .date_pick {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    margin-right: 20px;
  }
  .margin_top_table {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/userData/startAndStopLog.vue